"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.first = void 0;
var at_1 = require("./at");
/** @internal */
var first = function (array) { return (0, at_1.at)(array, 0); };
exports.first = first;
